// Libraries
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiInventoryPortal = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_INVENTORY_PORTAL_API_URL as string,
    prepareHeaders: (headers: Headers) => {
      headers.set(
        "x-api-key",
        process.env.ENV_INVENTORY_PORTAL_API_KEY as string,
      );
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiInventoryPortal",
  tagTypes: ["BonusInfo"],
});

export const apiAuth = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_COGNITO_URL as string,
    prepareHeaders: (headers: Headers) => {
      headers.set("x-api-key", process.env.ENV_AUTH_API_KEY as string);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiAuth",
});

export const apiPortalPricing = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_PORTAL_PRICING_API,
    prepareHeaders: (headers) => {
      headers.set(
        "x-api-key",
        process.env.ENV_PORTAL_PRICING_API_KEY as string,
      );
      headers.set("Content-Type", "application/json");
      headers.set("Env-Origin", process.env.ENV_ORIGIN as string);
      return headers;
    },
  }),
  endpoints: () => ({}),
});

export const apiAuthV2 = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_COGNITO_URL_V2 as string,
    prepareHeaders: (headers: Headers) => {
      headers.set("x-api-key", process.env.ENV_AUTH_API_KEY_V2 as string);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiAuthV2",
});

export const apiVim = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_INVENTORY_VIM_URL as string,
    prepareHeaders: (headers: Headers) => {
      headers.set("x-api-key", process.env.ENV_INVENTORY_VIM_API_KEY as string);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiVim",
});

export const apiGlobalApproval = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_GLOBAL_APPROVAL_API_URL as string,
    prepareHeaders: (headers: Headers) => {
      headers.set(
        "x-api-key",
        process.env.ENV_GLOBAL_APPROVAL_API_KEY as string,
      );
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiGlobalApproval",
});

export const apiPipefySerializer = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_PIPEFY_SERIALIZER_URL as string,
    prepareHeaders: (headers: Headers) => {
      headers.set(
        "x-api-key",
        process.env.ENV_PIPEFY_SERIALIZER_API_KEY as string,
      );
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiPipefySerializer",
});

export const apiDocumentReview = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_DOCUMENT_REVIEW_URL as string,
    prepareHeaders: (headers: Headers) => {
      headers.set(
        "x-api-key",
        process.env.ENV_DOCUMENT_REVIEW_API_KEY as string,
      );
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiDocumentReview",
});


export const apiBudgetRoute = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_BUDGET_ROUTE_URL as string,
    prepareHeaders: (headers: Headers) => {
      headers.set("x-api-key", process.env.ENV_BUDGET_ROUTE_API_KEY as string);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: "apiBudgetRoute",
  tagTypes: ["Rules"],
});